export enum CodeAccessTypes {
  sent = 'sent',
  notsent = 'notsent',
}

export const CodeGroupTitleMap = {
  [CodeAccessTypes.sent]: 'Shared',
  [CodeAccessTypes.notsent]: 'Pending',
};
